// filepath: c:\Users\maraz\OneDrive\Desktop\applicazione IA\vibe\src\services\firebase.ts
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Leggi le variabili d'ambiente
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID
};

// Verifica che le variabili siano caricate (opzionale ma utile per debug)
if (!firebaseConfig.apiKey) {
  console.error("Errore: Variabili d'ambiente Firebase non caricate correttamente!");
  // Potresti voler gestire questo caso in modo più robusto
}

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);